import { render, staticRenderFns } from "./returnDialog.vue?vue&type=template&id=7146c3e6&scoped=true&"
import script from "./returnDialog.vue?vue&type=script&lang=js&"
export * from "./returnDialog.vue?vue&type=script&lang=js&"
import style0 from "./returnDialog.vue?vue&type=style&index=0&id=7146c3e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7146c3e6",
  null
  
)

export default component.exports